export default __webpack_public_path__ + "static/media/mana5.f2104717.svg";